<template>
  <b-tabs content-class="" nav-class="ml-1">
    <b-tab no-body :title="$t('routes.EXCMCallLogList')">
      <b-card>
        <CallLogTable/>
      </b-card>
    </b-tab>
    <b-tab no-body :title="$t('menu.excmcalllogs.statistic')">
      <b-card>
        <CallLogStatisticTable/>
      </b-card>
    </b-tab>
  </b-tabs>
</template>

<script>
import CallLogTable from '@/components/Dashboard/Views/excmcalllog/CallLogTable'
import CallLogStatisticTable from '@/components/Dashboard/Views/excmcalllog/components/CallLogStatisticTable'

export default {
  name: 'CallLogList',
  components: {
    CallLogStatisticTable,
    CallLogTable
  },
  created () {
  },
  methods: {
  }
}
</script>
